import React from 'react'

import BannerVersion from './Version'
import BannerWarning from './Warning'
import BannerDebug from './Debug'
import WindowsUpdate from './WindowsUpdate'

export default function Banner() {
  return (
    <div
      className="force-light-mode"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 5,
      }}
    >
      <BannerVersion />
      <BannerWarning />
      <BannerDebug />
      <WindowsUpdate />
    </div>
  )
}
